import React, { useState, useEffect } from "react";
import ElementModal from "../../Pages/Kdf/EditKdf/elementModal/ElementModal";
import Button from "../../Elements/Button";
import FormFieldsSection from "../../Pages/Kdf/EditKdf/elementModal/elementSections/elementFormSection/FormFieldsSection";
import DisplayLanguagesSection from "../../Pages/Kdf/EditKdf/elementModal/elementSections/elementFormSection/DisplayLanguagesSection";
import useEditorHook from "../../Pages/Kdf/EditKdf/editorHook/useEditorHook";
import CustomForm from "../../CommonComponents/CustomForm/CustomForm";
import InternalExtendBeyondModal from "./InternalExtendBeyondModal";
import * as _ from "lodash";
const AddElementModal = ({
    openAddElementModal,
    closeModal,
    docData,
    docFiles,
    totalPages,
    zoom,
    applyDesiredAction,
}) => {
    // Pass openAddElementModal to useEditorHook
    const {
        tool,
        toolType,
        editElement,
        ToolSection,
        handleCloseModal,
        handleSubmitElement,
        handleChange,
        setTool,
        initialTool,
        initialEditElement,
        scrollActive,
        isChanged,
        setIsChanged,
        errorState,
        handleSubmitBtnState,
        showExtendModal,
        setShowExtendModal,geomatryAccordigToNormal
    } = useEditorHook(closeModal, docData, totalPages, zoom, applyDesiredAction, openAddElementModal); 

    const languages = docFiles?.filter((elem) => elem?.id !== docData?.id);

    const [isInitialRenderAfterOpen, setIsInitialRenderAfterOpen] = useState(true);
    //  const [initialTools, setInitialTools] = useState(tool);
    useEffect(() => {
        console.log("AddElementModal: openAddElementModal changed to:", openAddElementModal);
        if (openAddElementModal) {
            setIsInitialRenderAfterOpen(true);
        } else {
            setIsInitialRenderAfterOpen(true); // Reset for next open
        }
    }, [openAddElementModal]);

    useEffect(() => {
        if (isInitialRenderAfterOpen && openAddElementModal) {
            console.log("AddElementModal: Setting isInitialRenderAfterOpen to false with setTimeout(0)");
            const timer = setTimeout(() => {
                setIsInitialRenderAfterOpen(false);
            }, 0);
            return () => clearTimeout(timer);
        }
    }, [isInitialRenderAfterOpen, openAddElementModal, tool, editElement]); 

    useEffect(()=>{console.log(tool.tags)},[tool.flip , tool.tags])
    useEffect(() => {
    const hasChanged =
        !_.isEqual(tool, initialTool) ||
        !_.isEqual(editElement, initialEditElement);
    setIsChanged(hasChanged);
}, [tool, editElement, initialTool, initialEditElement]);


    const isDisabled = () => {
        if (!openAddElementModal) {
            return true;
        }

        console.log("isDisabled check:", {
            isInitialRenderAfterOpen: isInitialRenderAfterOpen,
            isChanged: isChanged,
            toolType: toolType,
            pageLinkVsPage: (+tool?.value?.page_link === +tool?.page)
        });


        if (toolType === 'Clone') {
            return (
                isInitialRenderAfterOpen ||
                (!isChanged && +tool?.value?.page_link === +tool?.page)
            );
        } else {
            return (
                isInitialRenderAfterOpen ||
                (!isChanged && !isInitialRenderAfterOpen) ||
                (+tool?.value?.page_link === +tool?.page)
            );
        }
    };

    // Footer with Save buttons
    const modalFooter = (
        <div className="text-end m-2">
            <Button
                classList={'success'}
                onClick={(e) =>
                    handleSubmitElement(
                        e,
                        tool?.element_type_name === 'Image' ? editElement?.id : null,
                        toolType === 'LightboxesToolbox' ? 'image' : ''
                    )
                }
                text={toolType === 'Clone' ? 'Clone' : 'Save'}
                type="submit"
                disabled={isDisabled()}
            />
        </div>
    );

    return (
        <ElementModal
            openModal={openAddElementModal}
            heading={ToolSection()?.header}
            handleCloseModal={handleCloseModal}
            footer={modalFooter}
        >
            {showExtendModal &&         <InternalExtendBeyondModal
                                        openModal={showExtendModal}
                                        closeModal={setShowExtendModal}
                                            tool={tool}
                                            setTool={setTool}
                                            initialTool={geomatryAccordigToNormal()}
                                            // setShowToast={} // To display messages (from useEditorHook or parent of AddElementModal)
                                        />}

             <div className="image-popup">
                <CustomForm className="popup-content">
                    {toolType !== 'Clone' && ToolSection()?.component}
                    {toolType !== 'LightboxesToolbox' && (
                        <>
                            <FormFieldsSection
                                handleChange={handleChange}
                                scrollActive = {scrollActive}
                                tool={tool}
                                toolType={toolType}
                                docData={docData}
                                editElement={editElement}
                                setTool={setTool}
                                totalPages={totalPages}
                                errorState={errorState}
                                zoom={zoom}
                                handleSubmitBtnState={handleSubmitBtnState}
                            />
                            {languages?.length > 0 && (
                                <DisplayLanguagesSection
                                    languages={languages}
                                    toolType={toolType}
                                    tool={tool}
                                    setTool={setTool}
                                    handleSubmitBtnState={handleSubmitBtnState}
                                />
                            )}
                            {toolType === 'Clone' && (
                                <em className="px-0">
                                    {/* Note: Before duplicating the element please change at least position (width, height, top, left) and/or page to be shown, otherwise the element will be placed above the original one. */}
                                </em>
                            )}
                        </>
                    )}
                </CustomForm>
            </div>
        </ElementModal>
    );
};

export default AddElementModal;
